import React from 'react';
import MediaQuery from 'react-responsive';
import styles from './Banner.module.sass';
import banner from '../../../../images/pages/regimen_finder/banner.jpg';
import BREAKPOINTS from '../../constants/breakpoints';

function Banner() {
  return (
    <MediaQuery query={`(min-width: ${BREAKPOINTS.DESKTOP_WIDTH_BREAKPOINT}px)`}>
      <div className={styles.banner}>
        <div className={styles.image}>
          <img src={banner} alt="" />
        </div>
        <div className={styles['text-block']}>
          <div className={styles.content}>
            <div className={styles.title}>
              For Skincare That&apos;s Uniquely Yours
            </div>
            <h1>
              Your
              <br />
              Volition
              <br />
              Regimen
            </h1>
            <div className={styles.letter}>
              R
            </div>
          </div>
        </div>
      </div>
    </MediaQuery>
  );
}

export default Banner;
